import React from 'react';

import Select, { StylesConfig } from 'react-select';

import styles from './Dropdown.module.scss';

const brandPrimaryColor = '#1d66dd';
const customStyles: StylesConfig = {
  control: (base, state): any => ({
    ...base,
    boxShadow: 'none',
    cursor: 'pointer',
    borderColor: brandPrimaryColor,
    color: brandPrimaryColor,
    backgroundColor: state.isFocused ? '#f2f7ff' : '',
    '&:hover': {
      color: brandPrimaryColor,
      borderColor: brandPrimaryColor,
      backgroundColor: '#f2f7ff',
    },
  }),
  option: (base): any => ({
    ...base,
    '&:hover': {
      color: brandPrimaryColor,
    },
  }),
  placeholder: (base): any => ({
    ...base,
    color: brandPrimaryColor,
  }),
  indicatorSeparator: (base): any => ({
    ...base,
    margin: 0,
    backgroundColor: brandPrimaryColor,
  }),
};

export interface DropdownProps {
  options: Array<{}>;
  onChange?: Function;
  prefix?: Function;
  placeholder: string;
  isSearchable?: boolean;
  isClearable?: boolean;
  zIndex?: number;
  error?: string;
  setFieldValue?: Function;
  callback?: Function;
  name?: string;
  arialabelledby?: string;
  defaultValue?: {
    value: string;
    label: string;
  };
}

export const Dropdown = (props: DropdownProps) => {
  return (
    <div className={styles.wrapper} style={{ zIndex: props.zIndex }}>
      <Select
        aria-labelledby={props.arialabelledby}
        options={props.options}
        placeholder={props.placeholder}
        isSearchable={props.isSearchable}
        onChange={async (selected) => {
          if (props.setFieldValue) {
            props.setFieldValue(props.name, selected.value);
          }
          if (props.callback) {
            await props.callback(selected);
          }
        }}
        isClearable={props.isClearable}
        defaultValue={props.defaultValue}
      />
      {props.prefix && props.prefix()}
      {props.error && <p className="help color-lp-red Help">{props.error}</p>}
    </div>
  );
};
